export const ROUTE_PARAMETERS_SET_VALUE = 'ROUTE_PARAMETERS_SET_VALUE';

export const SIMULATION_PARAMETERS_SET_VALUE = 'SIMULATION_PARAMETERS_SET_VALUE';

export const SIMULATION_SET_VALUE = 'SIMULATION_SET_VALUE';
